import { createSvgIcon } from '@mui/material';

export const MoreIcon = createSvgIcon(
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="M6.114 13.52c-.55 0-1.02-.195-1.412-.587a1.926 1.926 0 0 1-.588-1.412c0-.55.196-1.021.588-1.413a1.926 1.926 0 0 1 1.412-.588c.55 0 1.021.196 1.413.588.391.392.587.862.587 1.412 0 .55-.196 1.021-.587 1.413a1.926 1.926 0 0 1-1.413.588Zm6 0c-.55 0-1.02-.195-1.412-.587a1.926 1.926 0 0 1-.588-1.412c0-.55.196-1.021.588-1.413a1.926 1.926 0 0 1 1.412-.588c.55 0 1.021.196 1.413.588.391.392.587.862.587 1.412 0 .55-.196 1.021-.587 1.413a1.926 1.926 0 0 1-1.413.588Zm6 0c-.55 0-1.02-.195-1.412-.587a1.926 1.926 0 0 1-.588-1.412c0-.55.196-1.021.588-1.413a1.926 1.926 0 0 1 1.412-.588c.55 0 1.021.196 1.413.588.391.392.587.862.587 1.412 0 .55-.196 1.021-.587 1.413a1.926 1.926 0 0 1-1.413.588Z"
    />
  </svg>,
  'MoreIcon',
);
